<div class="engine-wrapper">
  <canvas #renderCanvas></canvas>
</div>
